import { isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import appInstall from '@/utils/appUtils/appInstall'

export const toOptions = (width, height) => [
  {
    mode: 'resize',
    width,
    height,
  },
]

export const redirectUrl = (redirect: string) => {
  const openWithBrowser = redirect.startsWith('https://') || redirect.startsWith('http://')
  if (isDuApp()) {
    if (openWithBrowser) {
      Jockeys.openNativePage('/web/browser', { url: redirect })
    } else {
      Jockeys.openNativePage(redirect)
    }
  } else {
    if (openWithBrowser) {
      window.location.href = redirect
    } else {
      appInstall()
    }
  }
}
